import React, { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";

import App from "./App";
import store from "./redux/store";
import "./assets/i18n"; //multi-language
import "./styles/app.css";
import "./styles/overrides.scss";
import "./styles/style.scss";
import "./styles/profile-manager.scss";
import "./styles/organisational-activity.scss";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const allowedEnvironments = ["uat-phase2", "production", "qa-phase2"];

const sentryConfig = {
  dsn: process.env.DSN,
  sendDefaultPii: true,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  tracesSampleRate: 1.0,
};

if (allowedEnvironments.includes(process.env.ENVIRONMENT)) {
  Sentry.init(sentryConfig);
}
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ToastContainer
      position="top-center"
      autoClose={3000}
      className="toastNew"
      pauseOnHover={false}
      closeOnClick={true}
    />
    <App />
  </Provider>,
);
